import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "../actions/api";

let slice = createSlice({
  name: "healthPlanProviders",
  initialState: {
    ProvidersList: [],
    total: 10 || 0,
    currentPage: 1,
    toPage: null,
    lastPage: null,
    loading: false,
  },
  reducers: {
    fetchedProvidersSuccess: (enrollee, action) => {
      enrollee.loading = false;
      enrollee.ProvidersList = Array.isArray(action.payload) ? action.payload : action.payload.data;
      enrollee.total = Array.isArray(action.payload) ? action.payload.length : action.payload.meta?.total || 0;
      enrollee.currentPage = action.payload.meta?.from || 1;
      enrollee.toPage = action.payload.meta?.to || action.payload.length || 10;
      enrollee.lastPage = action.payload.meta?.last_page || 1;
    },
    
    fetchedProvidersStart: (enrollee, action) => {
      enrollee.loading = true;
    },
    fetchedProvidersFailed: (enrollee, action) => {
      enrollee.loading = false;
    },
  },
});

const {
  fetchedProvidersSuccess,
  fetchedProvidersStart,
  fetchedProvidersFailed,
} = slice.actions;

export default slice.reducer;
const url = "/v1/admin/providers";

export const fetchProviders = (
  pageItems,
  page,
  searchField = "",
  searchValue = ""
) => {
  let query = `page_items=${pageItems}&page=${page}`;
  if (searchField && searchValue) {
    query += `&${searchField}=${encodeURIComponent(searchValue)}`;
  }
  return apiCallBegan({
    url: `${url}?${query}`,
    method: "GET",
    onSuccess: fetchedProvidersSuccess.type,
    onStart: fetchedProvidersStart.type,
    onError: fetchedProvidersFailed.type,
  });
};


 

export const getProviders = (state) => state.entities.enrolleeProviders;

